<template>
    <div ref="VoteBox" class="vote-box">
        <!-- 头部 -->
        <div class="title-bar">
            <led-timer v-if="timerRequired" :time-in-seconds="timeInSeconds" type="countdown" />
            <div class="title">{{ activity.title }}</div>
            <div class="stat-info">
                <span class="label">已提交 </span>
                <span class="data">{{ activity.joinMemberCount }}</span>
            </div>
        </div>
        
        <!-- 投票内容区域 -->
        <div class="result-box">
            <div v-for="(topic, index) in activity.topics" :key="topic.id" class="topic">
                <!-- <div > -->
                <div v-if="selectedTopicId === topic.id" class="subject">
                    <div class="question-type">{{ topic.type == 'MULTI' ? '多选' : '单选' }}</div>
                    <div class="question-no">{{ index + 1 }}.</div>
                </div>
                <div v-if="selectedTopicId === topic.id" class="content">
                    <!-- <div class="question-content" v-html="topic.subject"></div> -->
                    <div class="question-content" v-html="topic.subject"></div>
                    <div v-for="option in topic.options" :key="option.id" class="option-box">
                        <div class="option-row">
                            <div class="num-col">{{ String.fromCharCode(option.itemNo + 65) }}.</div>
                            <div class="content-col">
                                <div class="row">
                                    <div class="left-col" v-html="option.content"></div>
                                    <div class="right-col"></div>
                                </div>
                                <div class="row">
                                    <div class="left-col">
                                        <div class="progress-bar">
                                            <div :style="option.pbarStyleString"></div>
                                        </div>
                                    </div>
                                    <div class="right-col">
                                        <div class="stat-info">
                                            {{ option.choicePercent }}% ({{ option.choiceCount }} 人)
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import ledTimer from './ledTimer.vue';
import tool from '@/assets/scripts/tool.js';

export default {
    components: {
        ledTimer
    },

    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        }
    },
    
    data: function () {
        return {
            serverTimestamp: 0,
            memberCount: null,
            selectedTopicId: null,
            activity: {
                topics: [],
            },
            componentId: null,
            supportedEventNames: [
                'activity.vote.show',
                'activity.vote.newResult',
                'activity.vote.showTopic',
                'activity.vote.sortBy',
                'common.moveJoystick'],
        };
    },

    computed: {
        allSubmitted : function (){
            return false;
        },
        hasResults : function () {
            return this.activity.topics.length > 0;
        },

        timeInSeconds: function() {
            if ( ! this.timerRequired) return 0;
            let d = new Date(this.activity.autoEndTime);
            d = Math.floor(d.getTime() / 1000);
            return (d - this.serverTimestamp);
        },
        /**
         * If this vote activity requires the led timer shown in the title bar
         * @return {boolean}
         */
        timerRequired: function() {
            return this.activity.status === 'IN_PRGRS' && this.activity.autoEnd === 'Y';
        }
    },
    
    watch: {
        currentShow: function(newVal, oldVal) {
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.resetScene();
            }
        }
    },

    created: function () {
        
    },
    
    mounted: function () {
        this.componentId = this.$attrs.id;

        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },

    methods: {
        /**
         * The window message handler, 
         * make it a function for addEventListener and removeEventListener
         * @param  {Object} window message 
         * @return {voi}
         */
        windowMessageHandler: function(e) {
            let msg = e.data;
            // console.log('yunayuan.log1' + msg);
            if (!msg.eventName) return;
            if (this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            let msgData = msg.data;
            switch (msg.eventName) {
                case 'activity.vote.show':
                    if (this.isLock && this.currentShow === this.componentId) return;
                    this.handleShowVoteMessage(msgData);
                    break;
                case 'activity.vote.showTopic':
                    if (this.isLock && this.currentShow === this.componentId) return;
                    if (this.activity.id === msgData.id) {
                        this.handleShowTopicMessage(msgData);
                    }
                    break;
                case 'activity.vote.sortBy':
                    if (this.isLock && this.currentShow === this.componentId) return;
                    if (this.activity.id === msgData.id) {
                        this.handleSortByMessage(msgData);
                    }
                    break;
                case 'activity.vote.newResult':
                    console.log(this.activity.id,msgData.activity.id);
                    if (this.activity.id === msgData.activity.id) {
                        this.handleNewResultMessage(msgData);
                    }
                    break;
                case 'common.moveJoystick':
                    this.moveJoystick(msgData);
                    break;
                default:
                    // statements_def
                    break;
            }
        },

        /**
         * Handle activity.vote.show message
         * In this method, you should convert the content of each topic and option to HTML source code format
         * and get the global properties e.g. serverTimestamp and so on.
         * and than send the data to showVote method
         * @see  {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/02vote/#3-2-1}
         * @param  {Object} the message data
         * @return {void}
         */
        handleShowVoteMessage: function(msgData) {
            if ( ! msgData) return;
            const data = JSON.parse(JSON.stringify(msgData));
            data.activity.topics.forEach(t => {
                t.subject = tool.htmlspecialchars(t.subject);
                t.options.forEach(o => o.content = tool.htmlspecialchars(o.content));
            });
            this.serverTimestamp = data.serverTimestamp;
            this.memberCount = data.memberCount;
            this.activity = data.activity;
            if (this.activity.topics && this.activity.topics.length > 0) {
                this.selectedTopicId = this.activity.topics[0].id;
            };

            if (this.activity.joinMemberCount === 0) {
                this.activity.topics.forEach(t => {
                    t.options.forEach(o => {
                        o.choicePercent = 0;
                    });
                });
            };

            if (this.activity.joinMemberCount > 0) {
                this.activity.topics.forEach(t => {
                    t.options.forEach(o => {
                        const pct = new Number(o.choiceCount * 100 / this.activity.joinMemberCount);
                        o.choicePercent = pct.toFixed(0);
                        o.pbarStyleString = 'width: ' + pct.toFixed(2) + '%';
                    });
                });
            };

        },

        handleShowOptionMessage: function(option) {
            option.forEach(o => {
                const pct = new Number(o.choiceCount * 100 / this.activity.joinMemberCount);
                o.choicePercent = pct.toFixed(0);
                o.pbarStyleString = 'width: ' + pct.toFixed(2) + '%';
            });
        },

        /**
         * If some students submit their result, udpat the page
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/02vote/#3-3-4}
         * @param  {Object} msgData the message data
         * @return {void}
         */
        handleNewResultMessage: function(msgData) {
            console.log(msgData);
            if (!msgData) return;
            // console.log(msgData.activity.joinMemberCount);
            // this.memberCount = msgData.memberCount;
            this.activity.joinMemberCount = msgData.activity.joinMemberCount;
            msgData.activity.topics.forEach(t => {
                console.log(t,this.activity.topics);
                const myTopic = this.activity.topics.find(mt => t.id == mt.id);
                if (! myTopic) {
                    console.log('can not find topic in my topics', t);
                    return;
                };

                t.options.forEach(o => {
                    const myOption = myTopic.options.find(myOption => myOption.id === o.id);
                    if (! myOption) {
                        console.log('can not find option in my options', o);
                        return;
                    }
                    myOption.choiceCount = o.choiceCount;

                    const pct = new Number(myOption.choiceCount * 100 / this.activity.joinMemberCount);
                    myOption.choicePercent = pct.toFixed(0);
                    myOption.pbarStyleString = 'width: ' + pct.toFixed(2) + '%';
                });

                let sortBy = myTopic.sortBy;
                myTopic.options.sort((a, b) => {
                    if (a === b) return 0;
                    if (a == null && b != null) return -1;
                    if (a != null && b == null) return 1;
                    
                    if (!sortBy) sortBy = 'A-Z';
                    if (sortBy === 'A-Z') {
                        return a.itemNo - b.itemNo;
                    } else if (sortBy === '9-0') {
                        const d = b.choiceCount - a.choiceCount;
                        return d === 0 ? (a.itemNo - b.itemNo) : d;
                    } else {
                        console.log('I can not understand sort ', sortBy);
                    }
                });
            });

            

        },

        /**
         * Handle sort by message
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/02vote/#3-2-3}
         * @param  {Object} msgData the message data
         * @return {void}
         */
        handleSortByMessage: function(msgData) {
            if ( ! msgData) return;
            const topicId = msgData.topicId;
            const sortBy = msgData.sortBy;
            const index = this.activity.topics.findIndex(t => t.id === topicId);
            if (index === -1) {
                console.log('someone wants to sort vote by ', sortBy, ' for vote ', msgData.id, ', topic ', topicId, ', but I can not find the topic');
                return;
            }

            const topic = this.activity.topics[index];
            topic.sortBy = sortBy;
            topic.options.sort((a, b) => {
                if (a === b) return 0;
                if (a == null && b != null) return -1;
                if (a != null && b == null) return 1;
                if (sortBy === 'A-Z') {
                    return a.itemNo - b.itemNo;
                } else if (sortBy === '9-0') {
                    const d = b.choiceCount - a.choiceCount;
                    return d === 0 ? (a.itemNo - b.itemNo) : d;
                } else {
                    console.log('I can not understand sort ', sortBy);
                }
            });
            // console.log(this.activity.topics)
        },

        /**
         * Handle show topic message
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/02vote/#3-2-2}
         * @param  {Object} msgData the messga data
         * @return {void}
         */
        handleShowTopicMessage: function(msgData) {
            if (! msgData) return;
            this.selectedTopicId = msgData.topicId;
        },

        moveJoystick: function(msgData) {
            let VoteBox = this.$refs.VoteBox;
            let direction = msgData.direction;
            if (direction === 'LEFT') {
                return;
            } else if (direction === 'RIGHT') {
                return;
            } else if (direction === 'UP') {
                VoteBox.scrollTop -= 40;
            } else if (direction === 'DOWN') {
                VoteBox.scrollTop += 40;
            } else {
                return;
            }

        },
        
        /**
         * reset the scene
         * @return {void}
         */
        resetScene: function() {
            this.$refs.VoteBox.scrollTop = 0;
            this.activity.status = null;
        }

    }

};

</script>

<style scoped>
    .vote-box {
        padding-top: 80px;
        overflow-x: hidden;
        overflow-y: auto;
        z-index: 900;
    }

    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .title-bar {
        display: flex;
        align-items: flex-start;
        height: 40px;
        padding: 20px 40px 20px 40px;
        background-color: #191919;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
    }

    .title-bar .led-timer {
        flex-shrink: 0;
        flex-grow: 0;
        width: 320px;
    }

    .title-bar .stat-info {
        flex-grow: 0;
        flex-shrink: 0;
        text-align: right;
        line-height: 36px;
        vertical-align: middle;
    }

    .title-bar .stat-info .label {
        flex-grow: 1;
        font-size: 18px;
        color: #BBC2C6;
        vertical-align: middle;
        padding: 0 10px;
    }

    .title-bar .stat-info .data {
        display: inline-block;
        font-size: 30px;
        color: #ffffff;
        vertical-align: middle;
    }

    .title-bar .title {
        height: 40px;
        line-height: 40px;
        vertical-align: middle;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
        flex-grow: 1;
    }

    /* 空数据样式 */
    .empty-result-hint {
        position: absolute;
        left: 0px;
        top: 80px;
        right: 0px;
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .result-box {
        padding: 40px;
    }

    .topic {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .topic .subject {
        display: flex;
        height: 2.25rem;
        justify-content: center;
        align-items: center;
    }

    .topic .subject .question-type {
        flex-shrink: 0;
        flex-grow: 0;
        font-size: 24px;
        color: #BBC2C6;
        line-height: 36px;
        vertical-align: middle;
        padding-right: 20px;
        border-right: 2px solid #969696;
    }

    .topic .subject .question-no {
        font-size: 1.5rem;
        line-height: 2.25rem;
        vertical-align: middle;
        margin-left: 20px;
        color: #ffffff;
    }

    .topic .content {
        flex-grow: 1;
        text-align: left;
        padding-left: 20px;
        flex-basis: 100px;
        font-size: 1.5rem;
        color: #ffffff;
        line-height: 150%;
    }

    .topic .content .question-content {
        
    }

    .topic .content .option-box {
        padding-top: 40px;
    }

    .topic .content .option-box .option-row {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .topic .content .option-box .option-row .num-col {
        flex-grow: 0;
        flex-shrink: 0;
    }

    .topic .content .option-box .option-row .content-col {
        flex-grow: 1;
        flex-basis: 100px;
        flex-shrink: 0;
        padding-left: 20px;
    }

    .topic .content .option-box .option-row .content-col .row {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .topic .content .option-box .option-row .content-col .row:last-child {
        padding-top: 17px;
        align-items: center;   
    }

    .topic .content .option-box .option-row .content-col .row .left-col {
        flex-grow: 1;
        flex-basis: 100px;
        flex-shrink: 0;

    }

    .topic .content .option-box .option-row .content-col .row .left-col .progress-bar {
        height: 20px;
        background-color: #ffffff;
        border-radius: 10px;
        overflow: hidden;
    }

    .topic .content .option-box .option-row .content-col .row .left-col .progress-bar > div {
        width: 0%;
        height: 20px;
        background: #5A9BDC;
        border-radius: 10px;
        transition: width 300ms linear;
    }

    .topic .content .option-box .option-row .content-col .row .right-col {
        width: 200px;
        flex-shrink: 0;
        flex-grow: 0;
    }

    .topic .content .option-box .option-row .content-col .row .right-col .stat-info {
        width: 200px;
        text-align: right;
        font-size: 24px;
    }
   
   
</style>
